import { render, staticRenderFns } from "./TabTrappedArea.vue?vue&type=template&id=479a4cce&lang=pug"
import script from "./TabTrappedArea.vue?vue&type=script&lang=ts"
export * from "./TabTrappedArea.vue?vue&type=script&lang=ts"
import style0 from "./TabTrappedArea.vue?vue&type=style&index=0&id=479a4cce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports